import { Timeseries } from "../types.ts";

export function average(vs: (number | null)[]): number {
  const valid = vs.filter((v): v is number => v != null);
  if (valid.length === 0) return 0;
  let sum = 0;
  for (const v of valid) sum += v;
  return sum / valid.length;
}

/**
 * Aligns multiple timeseries by their timestamps, returning only data points
 * where all timeseries have values at the same timestamp.
 *
 * @param series - Array of timeseries to align
 * @returns Array of aligned timeseries with matching timestamps
 */
export function alignTimeseries(series: Timeseries[]): Timeseries[] {
  if (series.length === 0) return [];

  // Collect all data points by timestamp for each series
  const timestampMaps = series.map(ts => {
    const map = new Map<number, number>();
    ts.timestamps.forEach((timestamp, i) => {
      map.set(timestamp.getTime(), ts.data[i]);
    });
    return map;
  });

  // Find timestamps that exist in all timeseries
  const firstMap = timestampMaps[0];
  const commonTimestamps: number[] = [];

  for (const tsKey of firstMap.keys()) {
    if (timestampMaps.every(map => map.has(tsKey))) {
      commonTimestamps.push(tsKey);
    }
  }

  // Sort timestamps
  commonTimestamps.sort((a, b) => a - b);

  // Build aligned timeseries
  return series.map((_, seriesIndex) => {
    const map = timestampMaps[seriesIndex];
    return {
      timestamps: commonTimestamps.map(tsKey => new Date(tsKey)),
      data: commonTimestamps.map(tsKey => map.get(tsKey)!),
    };
  });
}
